import { Avatar, Button, Drawer, Flex, Select, Space } from "antd";
import { Link, useLocation, useNavigate } from "react-router";
import DropdownIcon from "../../../assets/icons/DropdownIcon";
import IMAGES from "../../../assets/images";
import { ENV_CONFIG } from "../../../config/global.config";
import { LANGUAGES } from "../../../constants/global.constants";
import useAuth from "../../../hooks/useAuth";
import { cn } from "../../../utils/global.utils";
import { isActivePath } from "../../../utils/string.utils";
import LogoutIcon from "../../user/_icons/LogoutIcon";
import { sidebarItems } from "../../user/constants";
import BdFlagIcon from "../_icons/BdFlagIcon";
import BdMiniFlagIcon from "../_icons/BdMiniFlagIcon";
import { menuItems } from "../constants";

type Props = {
  drawerVisible: boolean;
  closeDrawer: () => void;
};

export default function MobileDrawer({ drawerVisible, closeDrawer }: Props) {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated, logout, employee } = useAuth();

  const isOpenDashboard =
    location?.pathname.startsWith("/user") && isAuthenticated;

  return (
    <Drawer
      title={
        <Flex align="center" gap={16}>
          <BdFlagIcon />
          <Link to="/">
            <img
              src="/images/logo.svg"
              alt={ENV_CONFIG.APP_NAME}
              className="h-9 object-contain"
            />
          </Link>
        </Flex>
      }
      placement="right"
      onClose={closeDrawer}
      open={drawerVisible}
      width={280}
      bodyStyle={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        padding: 0,
      }}
    >
      <div className="flex flex-col h-full">
        <div className="flex-1 overflow-y-auto px-6 py-4 space-y-2">
          {isAuthenticated ? (
            <Flex
              align="center"
              gap={16}
              className="border-b pb-4 border-theme-zinc-200 cursor-pointer"
              onClick={() => navigate("/user/dashboard")}
            >
              <Avatar
                src={employee?.profilePhotoUrl || IMAGES.avatar}
                size={48}
                className="rounded-full"
              />
              <div>
                <h6 className="text-theme-zinc-700 text-base font-medium">
                  {employee?.fullName || employee?.email || "Unknown User"}
                </h6>
                <p className="text-theme-slate-500 text-base font-normal">
                  {employee?.phone || "Unknown Phone"}
                </p>
              </div>
            </Flex>
          ) : (
            <div className="space-y-2.5 border-b pb-5 border-theme-zinc-200">
              <Button
                variant="outlined"
                type="primary"
                size="middle"
                block
                className="rounded-full btn-outline-primary pt-1 min-w-[90px]"
                onClick={() => navigate(`/login`)}
              >
                লগইন
              </Button>
              <Button
                type="primary"
                size="middle"
                block
                className="rounded-full pt-1 min-w-[120px]"
                onClick={() => navigate(`/registration`)}
              >
                রেজিস্টার
              </Button>
            </div>
          )}

          {isOpenDashboard ? (
            <Space direction="vertical" size={0} style={{ width: "100%" }}>
              {sidebarItems.map((el) => {
                const isActive = isActivePath(1, el.path);

                return (
                  <Button
                    type="text"
                    block
                    key={el.path}
                    onClick={() => navigate(`/user/${el.path}`)}
                    className={cn(
                      "text-theme-zinc-700 text-base font-normal justify-start px-4 py-0 space-x-2",
                      isActive && "!text-theme-primary"
                    )}
                  >
                    {el.label}
                  </Button>
                );
              })}
            </Space>
          ) : (
            <Space direction="vertical" size={0} style={{ width: "100%" }}>
              {menuItems.map((el) => {
                const isActive = isActivePath(0, el.key);

                return (
                  <Button
                    type="text"
                    block
                    key={el.key}
                    onClick={() => navigate(`/${el.key}`)}
                    className={cn(
                      "text-theme-zinc-700 text-base font-normal justify-start px-4 py-0 space-x-2",
                      isActive && "!text-theme-primary"
                    )}
                  >
                    {el.label}
                  </Button>
                );
              })}
            </Space>
          )}

          {!isOpenDashboard && (
            <div className="pl-5 border-t border-theme-zinc-200 pt-2">
              <Select
                prefix={<BdMiniFlagIcon className="mr-1.5 rounded-sm" />}
                suffixIcon={<DropdownIcon />}
                className="language-select w-full"
                size="small"
                placeholder="ভাষা"
                defaultValue={"bangla"}
                options={LANGUAGES}
              />
            </div>
          )}
        </div>

        {isAuthenticated && (
          <div className="px-6 py-4">
            <Button
              type="primary"
              danger
              icon={<LogoutIcon />}
              block
              className="bg-theme-red-500 rounded-full text-sm font-medium"
              onClick={logout}
            >
              লগ আউট
            </Button>
          </div>
        )}
      </div>
    </Drawer>
  );
}
